<script setup lang="ts">
import NewsletterSignupForm from "@/components/signups/NewsletterSignupForm.vue";
</script>

<template>
  <div class="card card-compact bg-jade/10 border-2 border-jade/50">
    <div class="card-body">
      <div class="h3 font-semibold tracking-tight">Subscribe to our newsletter</div>
      <div>Claim your free membership to the private True Market Insiders' daily dispatch.</div>
      <NewsletterSignupForm/>
    </div>
  </div>
</template>

